<section
	[editableInStoryblok]="_editable"
	data-test-class="items-slider-section"
>
	<div class="section-spacing">
		<div class="section-inner section-gap">
			@let heading = title()[0];
			@if (heading) {
				<sb-heading-group-section
					[alignment]="heading.alignment"
					[content]="heading.content"
					[headingType]="heading.headingType"
					[overline]="heading.overline"
					[title]="renderedRichTextTitle()"
				/>
			}
			@if (itemSliderItems().length > 0) {
				<div class="max-md:-mx-3">
					<vp-items-slider [items]="itemSliderItems()" [uid]="_uid" />
				</div>
			}
		</div>
	</div>
</section>
